import { Helmet } from 'react-helmet-async';
import ClinicoDetails from '../components/clinico/clinicoDetails/ClinicoDetails';
import MainSection from '@/components/MainSection';
import { useTranslation } from 'react-i18next';
import Clinco from '../components/clinico/svg/Clinco';

export default function ClinicoPage() {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>Clinico</title>
                <meta name="description" content="Welcome to our clinico page. Explore our clinico and services." />
                <link rel="canonical" href="/clinico" />
            </Helmet>

            <div className="w-full mb-[100px] relative overflow-hidden rounded-b-[40px]">
                <MainSection
                    title={t('clinicoPage.mainTitle')}
                    description={t('clinicoPage.description')}
                    icon={<Clinco className="" />}
                />
            </div>

            <ClinicoDetails />
        </>
    );
}
